module.exports = __webpack_public_path__ + "img/gt.9e6c4331.svg";